export default "__VITE_ASSET__DHtfsQMJ__"